var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-wrapper" }, [
    _c("div", { staticClass: "login-panel row" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "login-panel-content" }, [
          _c("div", { staticClass: "logo" }, [
            _c("img", {
              attrs: { src: "assets/images/logo.svg", alt: "Calmit logo" }
            })
          ]),
          _c("div", { staticClass: "welcome-message" }, [
            _c("h1", {
              domProps: { innerHTML: _vm._s(_vm.trans("welcome_message")) }
            })
          ]),
          _vm.component === "loginForm"
            ? _c("div", { staticClass: "form-wrapper" }, [_c("login-form")], 1)
            : _vm._e(),
          _vm.component === "forgetPassword" &&
          _vm.email === undefined &&
          _vm.token === undefined
            ? _c(
                "div",
                { staticClass: "form-wrapper" },
                [_c("forget-password-form")],
                1
              )
            : _vm._e(),
          _vm.component === "resetPassword" &&
          _vm.email != "" &&
          _vm.token != ""
            ? _c(
                "div",
                { staticClass: "form-wrapper" },
                [
                  _c("reset-password-form", {
                    attrs: {
                      email: _vm.email,
                      token: _vm.token,
                      resetRoute: _vm.resetroute
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          false
            ? _c("div", { staticClass: "footer" }, [
                _c("a", { attrs: { href: _vm.trans("footer_link1_url") } }, [
                  _vm._v(_vm._s(_vm.trans("footer_link1_name")))
                ]),
                _vm._v(" | "),
                _c("a", { attrs: { href: _vm.trans("footer_link2_url") } }, [
                  _vm._v(_vm._s(_vm.trans("footer_link2_name")))
                ]),
                _vm._v(" | "),
                _c("a", { attrs: { href: _vm.trans("footer_link3_url") } }, [
                  _vm._v(_vm._s(_vm.trans("footer_link3_name")))
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 login-panel-img-wrapper" }, [
      _c("div", { staticClass: "login-panel-img" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }